"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconMoreOptions = void 0;
var React = __importStar(require("react"));
var IconMoreOptions = function (props) { return (React.createElement("svg", __assign({ width: "34px", height: "34px", viewBox: "0 0 34 34" }, props),
    React.createElement("g", { id: "More-options", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
        React.createElement("g", null,
            React.createElement("rect", { id: "Background", fill: "#F0F0F1", x: 0, y: 0, width: 34, height: 34, rx: 4 }),
            React.createElement("g", { id: "Icons/Menu/ellipsis-more", transform: "translate(6.000000, 6.000000)" },
                React.createElement("path", { d: "M18.562381,10.4761905 C19.3519048,10.4761905 19.9909524,11.1152381 19.9909524,11.9047619 C19.9909524,12.6478431 19.4248756,13.2576306 18.7000472,13.3267991 L18.562381,13.3333333 C17.7728571,13.3333333 17.1338095,12.6942857 17.1338095,11.9047619 C17.1338095,11.1152381 17.7728571,10.4761905 18.562381,10.4761905 Z M4.28552381,10.4761905 C5.07504762,10.4761905 5.71409524,11.1152381 5.71409524,11.9047619 C5.71409524,12.6478431 5.14801845,13.2576306 4.42319006,13.3267991 L4.28552381,13.3333333 C3.49695238,13.3333333 2.85695238,12.6942857 2.85695238,11.9047619 C2.85695238,11.1152381 3.49695238,10.4761905 4.28552381,10.4761905 Z M11.4288571,10.4761905 C12.2174286,10.4761905 12.8574286,11.1152381 12.8574286,11.9047619 C12.8574286,12.6478431 12.2905082,13.2576306 11.5663745,13.3267991 L11.4288571,13.3333333 C10.6393333,13.3333333 10.0002857,12.6942857 10.0002857,11.9047619 C10.0002857,11.1152381 10.6393333,10.4761905 11.4288571,10.4761905 Z", id: "path", fill: "#464650", fillRule: "evenodd" }),
                React.createElement("rect", { id: "padding", x: 0, y: 0, width: 22.8571429, height: 22.8571429 })))))); };
exports.IconMoreOptions = IconMoreOptions;
exports.IconMoreOptions.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconMoreOptions;
